/* eslint-disable @typescript-eslint/no-explicit-any */
import { ProductType } from 'sdk'
import { BigNumber } from 'ethers'

import React from 'react'
import { Transaction } from 'services'
import { SingleSelectInfo } from '../input-field/types'
// import { OmniProductType } from 'context/phuture-sdk'

export enum PresentationalStateActions {
  // Flag for price impact warnings
  ACKNOWLEDGE_PRICE_IMPACT,
  WARN_PRICE_IMPACT,
  SET_PRICE_IMPACT,
  RESET_PRICE_IMPACT,

  //Dollar values
  SET_INPUT_DOLLAR_VALUE,
  SET_OUTPUT_DOLLAR_VALUE,

  // Advanced setting actions
  SET_TRANSACTION_TYPE,
  SET_REDEMPTION_ASSET,
  SET_SLIPPAGE_TOLERANCE,
  SET_AUTO_SLIPPAGE,

  // tab change actions
  CHANGE_TAB_BUY,
  CHANGE_TAB_SELL,

  // approval request actions
  REQUEST_APPROVAL,
  REQUESTED_APPROVAL,
  RESPONSE_APPROVAL,

  // user input actions
  CHANGE_BUY_INPUT_AMOUNT,
  CHANGE_SELL_INPUT_AMOUNT,
  CHANGE_INPUT_AMOUNT_DOLLAR_VALUE,
  SET_RECEIVED_TOKENS,
  SET_SELECTED_ASSET,
  SET_LOADING_FOR_VALUES,

  // state from outside sources (contract etc)
  CHANGE_FEE,

  // modal actions
  OPEN_MODAL,
  CLOSE_MODAL,

  // tokens received modal actions
  OPEN_TOKENS_RECEIVED_MODAL,
  CLOSE_TOKENS_RECEIVED_MODAL,

  // set the latest transaction hash
  SET_TRANSACTION,
  RUNNING_TRANSACTION,

  // overall widget
  SUBMIT_TRANSACTION,
  SUBMITTING_TRANSACTION,
  SUCCESS_TRANSACTION,
  FAILURE_TRANSACTION,
  RESET_TRANSACTION,
  APPROVE_TRANSACTION,
}

export type PresentationalStateAction = {
  type: PresentationalStateActions
  payload?: any
}

type Coin = {
  name: string // ethereum, bitcoin, etc
  icon: string // fill with icon component
  symbol: string //ETH
  address: string // address of coin
  decimals: number // number of decimals
}

export type TransactableCoin = Coin & {
  outputAmount: BigNumber
  dollarValue: BigNumber
}

/**
 * The different transaction types
 */
export enum TransactionType {
  AUTO = 'auto',
  SWAP = 'swap',
  MINT_REDEEM = 'mint/redeem',
}

/**
 * The different stages of the whole transaction process.
 */
export enum TransactionState {
  IDLE = 'idle',
  SUBMITTING = 'submitting',
  SUBMITTED = 'submitted',
  SUCCESS = 'success',
  FAILURE = 'failure',
  APPROVE = 'approve',
}

/**
 * The different stages of the approval process, many of the stages may not be required thanks to OX
 */
export enum ApprovalStage {
  IDLE = 'idle',
  PENDING = 'pending',
  REQUESTED = 'requested',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

/**
 *  Different price impact states
 */
export enum PriceImpactState {
  NONE = 'none',
  WARN = 'warn',
  ACKNOWLEDGED = 'acknowledged',
}

export interface ReceivedToken extends SingleSelectInfo {
  usdcPrice: string
  nativePrice: string
  token: string
  decimals: number
}

export interface TransactionalState {
  productAddress: string
  productType: ProductType //OmniProductType |
  transactionState: TransactionState // this will update when the user submits the transaction
  transaction?: Transaction // this will update when the user submits the transaction
  runningTransaction?: boolean
  isBuying: boolean
  isSwapState: boolean
  fee: BigNumber
  receivedTokens: ReceivedToken[]
  selectedAsset: string
  loadingValues: boolean
  availableBalance: BigNumber
  inputAssetAmount: string
  inputIndexAmount: string
  inputCoin?: Coin
  transactableCoins: TransactableCoin[]
  amountInputDollarValue: BigNumber
  approvalStage: ApprovalStage
  transactionType: TransactionType
  redemptionAsset: string
  autoSlippage: boolean
  slippageTolerance: string
  currentPriceImpactPercentage: string
  modalOpen: boolean
  isTokensReceivedModalOpen: boolean
  priceImpactState: PriceImpactState
  inputDollarValue: string
  outputDollarValue: string
  dispatch: React.Dispatch<PresentationalStateAction>
}
export interface TransactionalContextProviderProps {
  children: React.ReactNode
}
